function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M57.7402 53.81H4.26016C2.16016 53.81 0.410156 52.13 0.410156 49.96V4.04C0.410156 1.94 2.09016 0.190002 4.26016 0.190002H57.6702C59.7702 0.190002 61.5202 1.87 61.5202 4.04V50.03C61.5202 52.13 59.8402 53.81 57.7402 53.81Z",
  fill: "#F0F0F0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M31.0011 10.55C35.6211 10.55 39.7511 13.77 40.8011 18.25C41.9211 22.87 39.7511 27.63 35.4811 29.66C34.2911 30.22 33.6611 30.99 33.5911 32.39C33.5911 33.79 32.2611 34.84 30.8611 34.77C29.4611 34.7 28.3411 33.58 28.2711 32.18C28.1311 29.17 29.8111 26.37 32.6811 25.04C34.2211 24.34 35.2711 23.22 35.6211 21.61C36.1811 18.88 34.3611 16.36 31.5611 15.94C28.9011 15.59 26.4511 17.69 26.3111 20.42C26.3111 20.7 26.3111 20.91 26.2411 21.19C25.9611 22.59 24.7011 23.5 23.3711 23.36C21.9711 23.22 20.9211 22.1 20.9211 20.7C20.7811 15.24 25.4011 10.55 31.0011 10.55Z",
  fill: "#D5D5D5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M33.5892 40.79C33.5892 42.26 32.3292 43.45 30.8592 43.45C29.3892 43.45 28.1992 42.19 28.1992 40.72C28.1992 39.25 29.4592 38.06 30.9292 38.06C32.3992 38.06 33.5892 39.32 33.5892 40.79Z",
  fill: "#D5D5D5"
});

var SvgOtherDocument = function SvgOtherDocument(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 54,
    viewBox: "0 0 62 54",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOtherDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/other-document.e134df70.svg";
export { ForwardRef as ReactComponent };